import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  updateOrInsertStudentProgressCheck,
  getCheckedProgressChecks,
  getCheckedProgressCheckswithType,
} from "../../../lib/studentprogresscheck";



export default function GlobalStudentProgressCheck({ studentId, type }) {
  const [studentProgressChecks, setStudentProgressChecks] = useState([]);
  const [checkedStudentProgressChecks, setCheckedStudentProgressChecks] =
    useState([]);


  // Fetch progress checks based on type
  const fetchProgressChecks = async () => {
    if (!type) {
      console.error("No progress check type provided");
      return;
    }

    //const checks = await getDataWithType("Awards");
    const checks = await getCheckedProgressCheckswithType(studentId, type);
    setStudentProgressChecks(checks);
    console.log("checks", checks);
  };



  // Fetch checked progress checks for the student
  const getCheckedStudentProgressChecks = async () => {
    const checkedChecks = await getCheckedProgressChecks(studentId);
    setCheckedStudentProgressChecks(
      checkedChecks.map((check) => check.progresscheckId)
    );
  };

  studentProgressChecks?.filter((studentCheck) => {
    // filter out checked progress checks
    return !checkedStudentProgressChecks.includes(studentCheck?.id);
  });

  const handleCheckboxChange = async (checkId, currentValue) => {
    await updateOrInsertStudentProgressCheck(
      studentId,
      checkId,
      !currentValue,
      type
    );
    fetchProgressChecks();
    getCheckedStudentProgressChecks();
  };



  useEffect(() => {
    fetchProgressChecks();
    getCheckedStudentProgressChecks();
    //setAssignedDate(getCurrentDateInput());
    //getStudentProgressTasks();
    //setDueDate(getCurrentDateInput());
  }, []);


  return (
    <>
      <div className="col-12 p-1">
        <div className="settings-inner-blk p-0">
        <div className="comman-space p-2 card wish-card">
            <h3>Student Progress Checks</h3>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Score</th>
                  <th>Checked</th>
                </tr>
              </thead>
              <tbody>
                {studentProgressChecks.map((check) => (
                  <tr key={check.progresscheckId}>
                    <td>{check.description}</td>
                    <td>{check.score}</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={check.isCheck}
                        onChange={() =>
                          handleCheckboxChange(check.progresscheckId, check.isCheck)
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

       

        
        </div>
      </div>
    </>
  );
}
